var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-gift.735a213d.png","uri@2x": __webpack_public_path__ + "icon-gift.20109905.png","uri@3x": __webpack_public_path__ + "icon-gift.e342f540.png",
    width: 44,
    height: 44
});